import './style.scss';

export function treatments_hero_block() {
    const block = document.querySelector('.treatments_hero_block');
    if (!block) return;
}

